<template>
  <div class="header">
    <div class="header-content">
      <div class="left">
        <a class="logo-link" href="/">
          <img src="//assets.cnbj1.mi-fds.com/assets/emi/logo_n.png">
        </a>
        <a class="nav-item" :class="{'actived': pageType == 'document'}" href="/v2/dist/api.html#/document">开发文档</a>
        <a class="nav-item" v-if="hasPrivilege" :class="{'actived': pageType == 'account'}" href="/v2/dist/api.html#/account">账户对接</a>
      </div>
      <div class="right">
        <el-dropdown v-if="isCookie">
          <span class="el-dropdown-link">
            <div class="content">
              <p v-if="hasPrivilege">{{companyName}}</p>
              <p v-if="hasPrivilege">{{accountId}}</p>
              <p v-if="hasPrivilege">{{xiaomiId}}</p>
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a href="/account/logout">退出</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <a v-else class="login-btn" href="javascript:void(0)" @click="login">登录</a>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'common/axios.js';
  import cookie from 'common/cookie.js';
  export default {
    name: 'api-header',
    props: {
      userInfo: Object
    },
    data() {
      return {
        isCookie: false,
        accountId: '',
        xiaomiId: '',
        hasPrivilege: false,
        companyName: ''
      }
    },
    computed: {
      pageType() {
        return this.$route.name;
      }
    },
    methods: {
      async getPrivilege() {
        try {
          const {data: {result}} = await axios.get('/v2/openapi/checkPrivilege');
          if (result) {
            this.accountId = result.accountId;
            this.xiaomiId = result.xiaomiId;
            this.hasPrivilege = result.hasPrivilege;
            this.companyName = result.companyName;
          }
        } catch (e) {
          console.log(e);
        }
      },
      login() {
        axios.get('/v2/openapi/checkPrivilege');
      }
    },
    mounted() {
      this.isCookie = cookie.getItem('serviceToken');
      if (this.isCookie) {
        this.getPrivilege();
      }
    }
  }
</script>